import axiosInstance from "./interceptor";

export const StudentApi = {
    getStudents: (empUrlId)=>{
        return axiosInstance.post("/students", {empUrlId})
    },
    sign: (image, id) =>{
        return axiosInstance.post("/sign", {image, id})
    }
}